<template>
  <div class="userList-main-wrapper cbg-white-container input-container theme--light p-3 v-card border-card">
    <div v-if="!showPatientProfile && !showDoctorProfile && !showAlliedProfile">

      <v-form ref="useForm" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" md="3" sm="6">
            <label for>Search By number/UID</label>
            <v-select v-model="selectValue" :items="items" :rules="[(v) => !!v || 'Item is required']" required
              @input="emptyValue(selectValue)" name="userProfile" id="userProfile" outlined hide-details></v-select>
          </v-col>

          <v-col cols="12" md="3" sm="6">
            <label for>{{ mobileUidd }}</label>
            <v-text-field v-if="selectValue == 'Mobile Number'" v-model="mobileNo" :rules="mobileRules" required
              :readonly="readonlyMobile" maxlength="10" outlined hide-details placeholder="Enter Number"></v-text-field>

            <v-text-field v-if="selectValue == 'UUID Number'" :rules="uidRules" label="UUID No." required v-model="uidNo"
              :readonly="readonlyUuid"></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <label class="col-sm-12 mb-0 d-none-mob"></label>
            <v-btn v-if="!openProfile" class="btn btn-primary mr-4" @click="submit()">Search</v-btn>

            <div v-if="openProfile" class>
              <v-btn :disabled="!valid" class="btn btn-danger mr-4" @click="clearData()">Clear Data</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>

      <div class="col-12 p-0 border-bottom" v-if="openProfile">
        <div class="col-12 row m-0 pb-0 mob-p-r-0 mob-p-l-0">
          <div class="col-12 p-0 mt-4">
            <h4>USER</h4>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 pl-0 pt-0 pb-0">
            <div class="card">
              <div class="card-body p-0">
                <div class="col-12 div-1">
                  <div class="col-12 row p-0 m-0">
                    <div class="col-md-8 p-0 col-12">
                      <div class="row profilebox">
                        <!-- changes done by durgesh on 20-1-2022 -->
                        <div class="col-md-6 col-lg-5 col-12 profile-view text-center">
                          <image-view v-if="profileData.profile_image" :src="profileData.profile_image &&
                              profileData.profile_image != ''
                              ? profileData.profile_image
                              : '/img/avatars/default-user.png'
                            "></image-view>
                          <image-view v-else :src="'/img/avatars/default-user.png'
                            "></image-view>
                        </div>
                        <!-- changes done by durgesh on 20-1-2022 -->
                        <div class="col-md-12 col-lg-7 col-12 mob-t-center">
                          <div class="w-67">
                            <h6 class="text-capitalize">{{ profileData.full_name }}</h6>
                            <div>
                              <star-rating :rating="profileData.rating_as_patient.average_rating
                                "></star-rating>
                            </div>
                            <div class="d-flex">
                              <div class="red-flag" v-if="profileData &&
                                profileData.red_flag_details &&
                                profileData.red_flag_details.total_count > 0
                                ">
                                <flagIcon />
                                &nbsp;{{
                                  profileData.red_flag_details.total_count
                                }}
                              </div>
                              <div class="black-flag ml-2" v-if="profileData && profileData.is_black_flag">
                                <flagIcon />
                                &#8377;
                                {{
                                  profileData &&
                                  profileData.black_flag_details.pending_amount
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="mob-t-center">
                            <p class="pl-0 pr-0 mar-b mar-t" v-if="profileData && profileData.dob">
                              DOB :
                              {{
                                profileData.dob
                                ? dayJS(profileData.dob).format(
                                  formats.date_format
                                )
                                : ""
                              }}
                            </p>
                            <p class="text-left mar-b mob-t-center" v-if="profileData && profileData.age">Age :{{
                              profileData.age }}</p>
                            <p class="pl-0 pr-0 text-left mob-t-center mar-b" v-if="profileData && profileData.uuid">UID :
                              {{ profileData.uuid }}</p>

                            <!-- <flagIcon class="flagw" />
                            &nbsp;{{
                              profileData.red_flag_details.total_count
                            }}-->
                          </div>
                          <!-- <div
                            class="black-flag ml-2"
                            v-if="profileData && profileData.is_black_flag"
                          >
                            <flagIcon class="flagw" />
                            &#8377;
                            {{
                              profileData &&
                              profileData.black_flag_details.pending_amount
                            }}
                          </div>-->
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 p-0 raisebox col-12">
                      <div class="d-flex justify-content-end contact-div mob-j-c">
                        <!-- <div class="inner-div" @click="goToChat(profileData._id)">
                          <messageSVG />
                        </div> -->
                        <div class="inner-div" @click="openRoleModal(profileData)">
                          <messageSVG />
                        </div>
                        <div class="inner-div" @click="openMobileModal(profileData.mobile)">
                          <phoneSVG />
                        </div>
                        <div class="inner-div" v-if="profileData.email" @click="openEmailWindow(profileData.email)">

                          <emailSVG />

                        </div>
                        <div class="action-div d-align small-table-padding">
                          <CDropdown color="link" size="lg" :caret="false" class="dropdowndocbox">
                            <template #toggler-content>
                              <verticalDotsSVG class="pb-2" />
                            </template>
                            <CDropdownItem v-if="permissions.includes('CAN_ACTIVE_DEACTIVE_USER')">Deactive
                            </CDropdownItem>
                            <CDropdownItem @click="addImageDialog = true">upload Certificate</CDropdownItem>
                          </CDropdown>
                        </div>
                      </div>
                      <div class="col-12 p-0 d-flex justify-content-end align-center margin-r">
                        <div v-if="permissions.includes('CAN_RAISE_REQUEST')"
                          class="col-12 div-3 p-0 text-right position-relative mob-t-center">
                          <v-btn class="btn btn-primary mr-4 positon-absolute mob-pos-s"
                            @click="openRaiseRequest(profileData)">Raise request</v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- changes done by durgesh on 20-1-2022 -->
                  <!-- <div class="col-12 p-0 row m-0"></div> -->
                </div>
                <div class="col-12 div-2 border-bottom" v-if="profileData &&
                  profileData.address &&
                  profileData.address.current_address &&
                  profileData.address.current_address.address_line_two
                  ">
                  <p class="mb-0">
                    <b>Address</b>
                  </p>
                  <p>
                    {{
                      profileData.address &&
                      profileData.address.current_address &&
                      profileData.address.current_address.address_line_two
                      ? profileData.address.current_address.address_line_two
                      : ""
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ........... end card .............. -->
        <div class="col-12 user-roles pt-0 mob-p-r-0 mob-p-l-0">
          <h6>Roles</h6>
          <div class="col-12 p-0">
            <div class="col row m-0 p-0">
              <v-btn depressed v-for="role in profileData.completed_profiles" :key="role" large class="mr-3 mb-2"
                @click="makeProfileUrl(role, profileData)">{{ role }}</v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- .............. user 12 end .............. -->
      <div class="col-12 row m-0 mt-3 pb-0" v-if="openProfile && dependentData != ''">
        <div class="col-12 p-0">
          <h4>DEPENDENT</h4>
        </div>

        <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 pl-0 pt-0 pb-0" v-for="dependent in dependentData"
          :key="dependent._id">
          <div class="card">
            <div class="card-body p-0">
              <div class="col-12 div-1">
                <div class="col-12 row p-0 m-0">
                  <div class="col-4 p-0">
                    <image-view :src="dependent.profile_image && dependent.profile_image != ''
                        ? dependent.profile_image
                        : '/img/avatars/default-user.png'
                      "></image-view>
                    <div class="w-67">
                      <h6 class="text-capitalize">{{ dependent.full_name }}</h6>
                      <div>
                        <star-rating :rating="dependent.rating_as_patient.average_rating"></star-rating>
                      </div>
                    </div>
                  </div>
                  <div class="col-8 p-0 d-flex justify-content-end contact-div">
                    <div class="inner-div" @click="goToChat(dependent._id)">
                      <messageSVG />
                    </div>
                    <div class="inner-div" v-if="dependent.mobile" @click="openMobileModal(dependent.mobile)">
                      <phoneSVG />
                    </div>
                    <div class="inner-div" v-if="dependent.email" :href="`mailto:${dependent.email}`">
                      <emailSVG />
                    </div>
                    <div>
                      <CDropdown color="link" size="lg" :caret="false">
                        <template #toggler-content>
                          <verticalDotsSVG />
                        </template>
                        <CDropdownItem>Deactive</CDropdownItem>
                      </CDropdown>
                    </div>
                  </div>
                </div>

                <div class="col-12 p-0 row m-0">
                  <div class="col-3 pl-0 pr-0" v-if="dependent && dependent.dob">
                    DOB :
                    {{
                      dependent.dob
                      ? dayJS(dependent.dob).format(formats.date_format)
                      : ""
                    }}
                  </div>
                  <div class="col-3 text-center">Age : {{ dependent.age }}</div>
                  <div class="col-6 pl-0 pr-0 d-flex justify-content-end" v-if="dependent && dependent.uuid">UID : {{
                    dependent.uuid }}</div>
                </div>
              </div>
              <div class="col-12 div-2 border-bottom" v-if="profileData &&
                profileData.address &&
                profileData.address.current_address &&
                profileData.address.current_address.address_line_two
                ">
                <p class="mb-0">
                  <b>Address</b>
                </p>
                <p>
                  {{
                    profileData.address &&
                    profileData.address.current_address &&
                    profileData.address.current_address.address_line_two
                    ? profileData.address.current_address.address_line_two
                    : ""
                  }}
                </p>
              </div>
              <div v-if="permissions.includes('CAN_RAISE_REQUEST')" class="col-12 div-3 d-flex justify-content-end">
                <v-btn class="btn btn-primary mr-4" @click="openRaiseRequest(profileData)">Raise request</v-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- .... end card 6 ..... -->
      </div>
      <profile-form-modal :profileData="myData"></profile-form-modal>
    </div>
    <div v-if="showPatientProfile">
      <patient-profile-summary-details @close="closeProfileSummary('patient')"
        :userId="userId"></patient-profile-summary-details>
    </div>
    <div v-if="showDoctorProfile">
      <doctor-profile-summary-details @close="closeProfileSummary('doctor')"
        :userId="userId"></doctor-profile-summary-details>

    </div>
    <div v-if="showAlliedProfile">
      <allied-profile-summary-details @close="closeProfileSummary('allied')"
        :userId="userId"></allied-profile-summary-details>

    </div>




    <show-role-modal v-if="showRoleModal" :showRoleModal="showRoleModal" :user="user"
      :initiateChatWithSelectedRole="initiateChatWithSelectedRole" @close="showRoleModal = false"></show-role-modal>
    <v-dialog persistent v-if="addImageDialog" v-model="addImageDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">Upload certificate</v-card-title>

        <v-card-text>
          <input class="form-control" placeholder="Certificate Name" v-model="certificate_type" />
          <span v-if="certificate_type.length === 0 && certificate_name_alert == true"
            class="text-danger required-fields">
            {{ "This field is required." }}
          </span>
        </v-card-text>
        <v-card-text>
          <file-upload media='image' :accept="accepted" :created_for="profileData._id" label="upload" refName='upload7098'
            role='patient' :multiple="false" module='docsmart_certificate' :drop="true"
            :uploadFileToServer="uploadFileToServer" :uploadedImg="uploadedImg" @uploaded="fileUploaded"
            :isBlogImage="false" :certificate_type="certificate_type" :tentative_date="new Date()"></file-upload>
          <span v-if="fileList.length === 0 && upload_alert == true" class="text-danger required-fields">
            {{ "This field is required." }}
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeModal()">Close</v-btn>
          <v-btn color="success" @click="uploadImage()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FileUpload from "@/components/FileUpload.vue";
import config from "@/config.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
const profileFormModal = () =>
  import("@/components/modals/profileFormModal.vue");
const starRating = () => import("@/views/dashboardNew/starRating.vue");
const patientProfileSummaryDetails = () =>
  import("@/views/dashboardNew/userListing/patientProfileSummaryDetails");
const doctorProfileSummaryDetails = () =>
  import("@/views/dashboardNew/userListing/doctorProfileSummaryDetails.vue");
  const alliiedProfileSummaryDetails = () =>
  import("@/views/dashboardNew/userListing/alliedProfileSummaryDetails.vue");
const showRoleModal = () =>
  import("@/components/modals/newRoleModal.vue");
const Image = () => import("@/components/image.vue");
import { pickSvg } from "@/views/SVG";
import ChatMixin from "@/common/ChatMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [ChatMixin],
  props: {},
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  components: {
    FileUpload,
    "profile-form-modal": profileFormModal,
    "star-rating": starRating,
    "image-view": Image,
    "show-role-modal": showRoleModal,
    "patient-profile-summary-details": patientProfileSummaryDetails,
    "doctor-profile-summary-details": doctorProfileSummaryDetails,
    "allied-profile-summary-details":alliiedProfileSummaryDetails,
    ...pickSvg(
      "verticalDotsSVG",
      "phoneSVG",
      "emailSVG",
      "flagIcon",
      "messageSVG",

    )
  },
  data() {
    return {
      accepted: "image/png,image/jpg,image/jpeg,application/pdf",
      uploadFileToServer: false,
      addImageDialog: false,
      showRoleModal: false,
      readonlyMobile: false,
      readonlyUuid: false,
      value: "Mobile Number",
      myDemoData: [],
      mobileUidd: "Mobile No.",
      valid: true,
      name: "",
      mobileRules: [
        v => !!v || "Mobile no is required",
        v => !isNaN(v) || "Please enter valid mobile number",
        v => v.length == 10 || "Please enter valid mobile number"
      ],
      uidRules: [v => !!v || "UUID is required"],
      select: null,
      items: ["Mobile Number", "UUID Number"],
      isLoading: false,
      errorMsg: false,
      selectValue: "Mobile Number",
      mobileNo: "",
      uidNo: "",
      pin: "",
      name: "",
      userMobile: "",
      email: "",
      category: "",
      subject: "",
      description: "",
      ticketModal: false,
      options: ["query", "suggestion", "feedback", "complaint"],
      openProfile: false,
      profileData: {},
      dependentData: [],
      myData: {},
      forRole: "Mobile Number",
      centerList: [],
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2
      },
      dayJS,
      formats,
      myData: {},
      config,
      showPatientProfile: false,
      showDoctorProfile: false,
      showAlliedProfile :false,
      userId: "",
      user: {},
      uploadedImg: [],
      fileList: [],
      upload_alert: false,
      certificate_type: "",
      certificate_name_alert: false,
    };
  },

  methods: {
    fileUploaded(files, uploaded, name) {
      this.fileList = files;
      if (this.fileList.length > 0) {
        this.upload_alert = false
      }
      if (uploaded) {
        this.fileList = [];
        this.sendNotification()
        this.closeModal();
      }
    },

    closeModal() {
      this.certificate_type="";
      this.uploadFileToServer = false;
      this.addImageDialog = false;
      this.upload_alert = false;
    },

    uploadImage() {
      if (this.fileList.length > 0 && this.certificate_type != "") {
        this.uploadFileToServer = true
      } else {
        if (!this.certificate_type) {
          this.certificate_name_alert = true;

        }
        if (this.fileList.length === 0) {
          this.upload_alert = true
        }
      }

    },
    initiateChatWithSelectedRole(role, user) {
      this.goToChat(user, role)

    },
    sendNotification() {
      let url = `${config.BASE_URL}api/v2/admin/system-notifications`;

      let input = {
        role: 'patient',
        message: `Hi ${this.profileData.full_name}, your ${this.certificate_type} has been uploaded. You can access it by going to Menu > Record > Document.`,
        // sms: `Hi ${this.profileData.full_name}, your ${this.certificate_type} can be accessed by downloading the DocSmart app, log in as Patient and go to Menu > Record >Document.To download the app, visit www.docsmart.in/qr`,       
        sms: `Hi ${this.profileData.full_name}, your ${this.certificate_type} can be accessed by downloading the DocSmart app, log in as user and go to Menu > Record >Document. To download the app, visit www.docsmart.in/qr`,
        attachments: "",
        filter: {
          user_ids: [{_id:this.profileData._id,name:this.profileData.full_name}]
        },
        send_chat: false,
        send_sms: true,
      };

      this.$http.post(url, input).then((response) => {
        if (response.body.status) {
          this.$swal("Document uploaded successfully . ");
        }
      });
    },
    goToChat(user, role) {
      this.$http
        .post(`${config.BASE_URL}api/v2/admin/system-chats`, {
          user_id: user._id,
          selected_role: role
        })
        .then((response) => {
          if (response.body.status) {
            this.$router.push({
              name: "chat",
              params: {
                chatId: response.body.data._id,
                user_name: user.full_name
              },
            });
          }
        });
    },
    openMobileModal(mobile) {
      this.$swal({
        text: mobile,
        allowOutsideClick: true,
        showCancelButton: false,
        confirmButtonText: "Ok"
      });

    },
    openRoleModal(userdata) {
      this.showRoleModal = true
      this.user = userdata
    },
    openRole(data) {
      const sendData = {
        role: data,
        roleDialog: true
      };
      this.$store.commit("general/setModal", sendData);
    },
    openRaiseRequest(data) {
      this.myData = data;
      const sendUserData = {
        userData: data,
        roleDialog: true
      };
      this.$store.commit("general/setProfileFormModal", sendUserData);
    },
    emptyValue(data) {
      this.$refs.useForm.resetValidation();
      this.openProfile = false;
      this.profileData = {};
      this.centerList = [];
      this.mobileNo = "";
      this.pin = "";
      this.forRole = "";
      this.readonlyMobile = false;
      this.readonlyUuid = false;
      if (data === "UUID Number") {
        this.uidNo = "";
        this.mobileUidd = "UUID No.";
      } else {
        this.mobileNo = "";
        this.mobileUidd = "Mobile No.";
      }
    },
    clearData() {
      this.$refs.useForm.resetValidation();
      this.openProfile = false;
      this.profileData = {};
      this.centerList = [];
      this.dependentData = [];
      this.mobileNo = "";
      this.pin = "";
      this.forRole = "";
      this.readonlyMobile = false;
      this.readonlyUuid = false;
    },
    submit() {
      if (this.$refs.useForm.validate()) {
        let obj = {};
        if (this.selectValue === "Mobile Number") {
          obj.mobile = this.mobileNo;
        } else {
          obj.uuid = this.uidNo;
        }
        let url = `${config.BASE_URL}api/v2/admin/users/details`;
        this.$http.post(url, obj).then(response => {
          if (response.body.status) {
            this.isLoading = false;
            this.openProfile = true;
            if (this.selectValue === "Mobile Number")
              this.readonlyMobile = true;
            else this.readonlyUuid = true;
            this.profileData = response.body.data.userDetails;
            this.dependentData = response.body.data.user_dependents;
            this.centerList = response.body.data.centers_list;
            this.errorMsg = false;
          } else {
            this.isLoading = false;
            this.errorMsg = true;
            this.$swal({
              text: "User not found",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok"
            });
          }
        });
      }
    },
    openEmailWindow(email) {
      window.open('mailto:' + email)
    },
    fetchDependent() {
      this.$http
        .get(`${config.NEW_BASE_URL}api/v2/dependent`)
        .then(response => {
          if (response.body.status) {
            this.dependentData = response.body.data;
          }
        });
    },
    submitForm() {
      let obj = {
        user_name: this.name,
        mobile: this.userMobile,
        email: this.email,
        description: this.description,
        subject: this.subject,
        ticket_type: this.category,
        // assigned_team: reqBody.assigned_team,
        created_by: this.userDetails ? this.userDetails._id : null,
        imageval: null
      };
      let url = config.BASE_URL + "api/v2/user/ticket/create";
      this.$http.post(url, obj).then(response => {
        if (response.body.status) {
          this.ticketModal = false;
        }
      });
    },
    makeProfileUrl(role, user) {
      this.userId = user._id;
      switch (role) {
        case "patient":
          this.showPatientProfile = true;
          break;
        case "allied":
          this.showAlliedProfile = true;
          break;
        case "doctor":
          this. showDoctorProfile = true;

          break;
        case "pharmacy":
          this.$router.push({
            path: "/centreListing",
            name: "Centre Listing",
            params: {
              role: role,
              user: user
            }

          });
          break;
        case "diagnostics-lab":
          this.$router.push({
            path: "/centreListing",
            name: "Centre Listing",
            params: {
              role: role,
              user: user
            }

          });
          break;
        case "bloodbank":
          this.$router.push({
            path: "/centreListing",
            name: "Centre Listing",
            params: {
              role: role,
              user: user
            }

          });
          break;
        case "ambulance":
          this.$router.push({
            path: "/centreListing",
            name: "Centre Listing",
            params: {
              role: role,
              user: user
            }

          });
          break;
        case "hospital":
          this.$router.push({
            path: "/hospitalListing",
            name: "Hospital Listing",
            params: {
              role: role,
              user: user
            }

          });
          break;

      }
    },

    closeProfileSummary(role) {
      switch (role) {
        case "patient":
          this.showPatientProfile = false;
          break;
        case "doctor":
          this.showDoctorProfile = false;
          break;
        case "allied":
          this.showAlliedProfile = false;
          break;



      }
    },


  },
  created() {
    if (this.$router.history.current.query.mobile) {
      this.mobileNo = this.$router.history.current.query.mobile;
      this.submit();
    }
  }
};
</script>

<style lang="scss" scoped>
.red-flag {
  svg {
    fill: #bd0200;
  }
}

.black-flag {
  svg {
    fill: #000;
  }
}
</style>

